import type { DesiredContentSize } from "@/lib/agent-presentation-types";

const MAX_DIMENSION = 4000;
const MAX_ASPECT_RATIO = 20;

function boundedPositive(value: unknown, max: number): number | undefined {
  return typeof value === "number" &&
    Number.isFinite(value) &&
    value > 0 &&
    value <= max
    ? value
    : undefined;
}

/** Undefined means absent; null means a malformed wire value. */
export function parseDesiredContentSize(
  value: unknown,
): DesiredContentSize | null | undefined {
  if (value === undefined) return undefined;
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const record = value as Record<string, unknown>;
  const provided = ["width", "height", "aspect_ratio"].filter(
    (key) => record[key] !== undefined,
  );
  if (provided.length === 0) return null;
  const width = boundedPositive(record.width, MAX_DIMENSION);
  const height = boundedPositive(record.height, MAX_DIMENSION);
  const aspectRatio = boundedPositive(record.aspect_ratio, MAX_ASPECT_RATIO);
  if (
    (record.width !== undefined && width === undefined) ||
    (record.height !== undefined && height === undefined) ||
    (record.aspect_ratio !== undefined && aspectRatio === undefined)
  ) {
    return null;
  }
  return {
    ...(width !== undefined ? { width } : {}),
    ...(height !== undefined ? { height } : {}),
    ...(aspectRatio !== undefined ? { aspect_ratio: aspectRatio } : {}),
  };
}
